import { useNavigate } from "react-router-dom";
import { fullName } from "@/lib/api";
import { Cake } from "lucide-react";

const label = (bday) => {
  const [m, d] = bday.split("/").map((x) => parseInt(x, 10));
  const now = new Date();
  let next = new Date(now.getFullYear(), m - 1, d);
  if (next < new Date(now.getFullYear(), now.getMonth(), now.getDate())) {
    next = new Date(now.getFullYear() + 1, m - 1, d);
  }
  const days = Math.round((next - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Tomorrow";
  return `in ${days} days`;
};

export const BirthdaysWidget = ({ birthdays }) => {
  const navigate = useNavigate();
  return (
    <div
      data-testid="birthdays-widget"
      className="bg-[#0A1F44] text-[#F3F5F8] p-6 border-l-4 border-[#C0982E]"
    >
      <div className="flex items-center gap-2 mb-5">
        <Cake className="w-4 h-4 text-[#C0982E]" strokeWidth={1.5} />
        <h3 className="text-xs uppercase tracking-[0.2em] text-[#F3F5F8]/80 font-serif">
          Upcoming Birthdays
        </h3>
      </div>
      {birthdays.length === 0 ? (
        <p className="text-sm text-[#F3F5F8]/50">No birthdays coming up.</p>
      ) : (
        <ul className="space-y-4">
          {birthdays.map((s) => (
            <li
              key={s.id}
              data-testid={`birthday-item-${s.id}`}
              onClick={() => navigate(`/staff/${s.id}`)}
              className="cursor-pointer group"
            >
              <div className="flex items-baseline justify-between gap-2">
                <span className="font-serif text-xl group-hover:text-[#C0982E] transition-colors">
                  {fullName(s)}
                </span>
                <span className="font-serif text-xl text-[#F3F5F8]/70 shrink-0">{s.birthday}</span>
              </div>
              <span className="text-[11px] uppercase tracking-wider text-[#C0982E]">
                {label(s.birthday)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
